const solutionRoute = [
  {
    path: '/solution',
    component: () => import('@/views/solution'),
    redirect: '/solution/index',
    meta: {
      title: '解决方案',
      breadcrumb: true,
      layout: 'DefaultLayout'
    },
    children: [
      {
        path: "index",
        component: () => import('@/views/solution/main/index.vue'),
        hidden: true,
        meta: {
          title: '解决方案',
          breadcrumb: false
        }
      },
      {
        path: '1',
        component: () => import('@/views/solution/Scheme1.vue'),
        meta: {
          title: '智慧园区',
          breadcrumb: true
        }
      },
      {
        path: '2',
        component: () => import('@/views/solution/Scheme2.vue'),
        meta: {
          title: '智慧校园',
          breadcrumb: true
        }
      },
      {
        path: '3',
        component: () => import('@/views/solution/Scheme3.vue'),
        meta: {
          title: '智慧社区',
          breadcrumb: true
        }
      },
      {
        path: '4',
        component: () => import('@/views/solution/Scheme4.vue'),
        meta: {
          title: '机器视觉',
          breadcrumb: true
        }
      },
      {
        path: '5',
        component: () => import('@/views/solution/Scheme5.vue'),
        meta: {
          title: '智慧景区',
          breadcrumb: true
        }
      },
      {
        path: '6',
        component: () => import('@/views/solution/Scheme6'),
        meta: {
          title: '智慧城管',
          breadcrumb: true
        }
      },
      {
        path: '7',
        component: () => import('@/views/solution/Scheme7.vue'),
        meta: {
          title: '智能家居',
          breadcrumb: true
        }
      },
      {
        path: '8',
        component: () => import('@/views/solution/Scheme8.vue'),
        meta: {
          title: '智慧公交',
          breadcrumb: true
        }
      },
      {
        path: '9',
        component: () => import('@/views/solution/Scheme9.vue'),
        meta: {
          title: '智慧景区',
          breadcrumb: true
        }
      }
    ]
  },
]
export default solutionRoute
